(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flocage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFlocage(root) {
    if (!root || root.dataset.flocBound === 'true') return;
    root.dataset.flocBound = 'true';

    var nameOut = root.querySelector('[data-floc-name]');
    var numOut  = root.querySelector('[data-floc-number]');
    var nameIn  = root.querySelector('[data-floc-input-name]');
    var numIn   = root.querySelector('[data-floc-input-number]');
    var bases   = root.querySelectorAll('.floc-base');
    var swatches = root.querySelectorAll('[data-floc-color]');

    function syncName() {
      if (!nameOut || !nameIn) return;
      var v = (nameIn.value || '').toUpperCase().replace(/[^A-ZÀ-ÖØ-Þ0-9 .'-]/g, '');
      nameOut.textContent = v.length ? v : 'TON NOM';
    }

    function syncNumber() {
      if (!numOut || !numIn) return;
      var raw = numIn.value;
      if (raw === '' || raw === null) { numOut.textContent = '10'; return; }
      var n = parseInt(raw, 10);
      if (isNaN(n)) { numOut.textContent = '10'; return; }
      if (n < 0) n = 0;
      if (n > 99) { n = 99; numIn.value = '99'; }
      numOut.textContent = String(n);
    }

    function setColor(hex) {
      if (!hex) return;
      for (var i = 0; i < bases.length; i++) { bases[i].setAttribute('fill', hex); }
      // pick legible ink for name/number against the base
      var light = isLight(hex);
      var ink = light ? '#0B0B0C' : '#F7F6F2';
      if (nameOut) nameOut.setAttribute('fill', ink);
      if (numOut)  numOut.setAttribute('fill', ink);
    }

    function isLight(hex) {
      var c = hex.replace('#', '');
      if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
      var r = parseInt(c.substr(0,2),16),
          g = parseInt(c.substr(2,2),16),
          b = parseInt(c.substr(4,2),16);
      return (0.2126*r + 0.7152*g + 0.0722*b) > 150;
    }

    if (nameIn) nameIn.addEventListener('input', syncName);
    if (numIn)  numIn.addEventListener('input', syncNumber);

    for (var s = 0; s < swatches.length; s++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          for (var j = 0; j < swatches.length; j++) {
            swatches[j].classList.remove('is-active');
            swatches[j].setAttribute('aria-pressed', 'false');
          }
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          setColor(btn.getAttribute('data-floc-color'));
        });
      })(swatches[s]);
    }

    // initial state
    syncName();
    syncNumber();
    var active = root.querySelector('[data-floc-color].is-active');
    setColor(active ? active.getAttribute('data-floc-color') : '#0B0B0C');
  }

  function boot() {
    var roots = document.querySelectorAll('[data-flocage]');
    for (var i = 0; i < roots.length; i++) initFlocage(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Shopify theme editor — re-init when section reloads
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-flocage]');
    if (r) { r.dataset.flocBound = 'false'; initFlocage(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var btn = root.querySelector('[data-copy-link]');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';

    var labelEl = btn.querySelector('[data-copy-label]');
    var original = labelEl ? labelEl.textContent : '';
    var resetTimer;

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url') || window.location.href;

      var done = function () {
        btn.classList.add('is-copied');
        if (labelEl) labelEl.textContent = 'Lien copié';
        clearTimeout(resetTimer);
        resetTimer = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (labelEl) labelEl.textContent = original;
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(fallback);
      } else {
        fallback();
      }

      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = url;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  }

  document.querySelectorAll('[data-post]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  const root = document.currentScript && document.currentScript.previousElementSibling;
  const section = (root && root.matches && root.matches('[data-cart-page]')) ? root : document.querySelector('[data-cart-page]');
  if (!section) return;

  const form = section.querySelector('.cartpage__form');
  if (!form) return;

  // +/- steppers: update the matching name="updates[]" input, then submit (server-side update).
  let submitTimer = null;
  function scheduleUpdate() {
    clearTimeout(submitTimer);
    submitTimer = setTimeout(function () {
      // Submit as an "update" request (no checkout button name carried).
      form.requestSubmit ? form.requestSubmit() : form.submit();
    }, 550);
  }

  section.querySelectorAll('[data-qty]').forEach(function (qty) {
    const input = qty.querySelector('input[name="updates[]"]');
    if (!input) return;
    const dec = qty.querySelector('[data-dec]');
    const inc = qty.querySelector('[data-inc]');
    if (dec) dec.addEventListener('click', function () {
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
      scheduleUpdate();
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 0) + 1;
      scheduleUpdate();
    });
    input.addEventListener('change', scheduleUpdate);
  });

  // Note: persist quietly via the Cart AJAX API so it isn't lost on checkout (best-effort).
  const note = section.querySelector('#cart-note');
  if (note) {
    let noteTimer = null;
    note.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {});
      }, 700);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-collection]').forEach(function (root) {
      root.querySelectorAll('[data-filter-reset]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('[data-filter].is-active').forEach(function (chip) {
            chip.classList.remove('is-active');
          });
          root.querySelectorAll('[data-pcard]').forEach(function (c) { c.classList.remove('hide'); });
          var none = root.querySelector('[data-no-results]'); if (none) none.classList.add('hide');
          var count = root.querySelector('[data-result-count]');
          var total = root.querySelectorAll('[data-product-grid] [data-pcard]').length;
          if (count && total) count.textContent = total;
          var panel = root.querySelector('[data-filter-panel]'); if (panel) panel.classList.remove('is-open');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
(function(){
  var open=document.querySelector('[data-pwd-open]'),modal=document.querySelector('[data-pwd-modal]'),close=document.querySelector('[data-pwd-close]');
  if(open&&modal){open.addEventListener('click',function(){modal.classList.add('is-open')});}
  if(close&&modal){close.addEventListener('click',function(){modal.classList.remove('is-open')});}
  if(modal){modal.addEventListener('click',function(e){if(e.target===modal)modal.classList.remove('is-open')});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  // Affiche la barre sticky une fois le bouton principal hors viewport.
  function initSticky() {
    document.querySelectorAll('.product[data-product]').forEach(function (root) {
      var sticky = root.querySelector('[data-product-sticky]');
      var add = root.querySelector('.product__add');
      if (!sticky || !add) return;
      if (!('IntersectionObserver' in window)) { sticky.classList.add('is-visible'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) sticky.classList.remove('is-visible');
          else if (e.boundingClientRect.top < 0) sticky.classList.add('is-visible');
        });
      }, { rootMargin: '0px 0px -60% 0px' });
      io.observe(add);
    });
  }
  if (document.readyState !== 'loading') initSticky();
  else document.addEventListener('DOMContentLoaded', initSticky);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.auth');
    roots.forEach(function (root) {
      var toggle = root.querySelector('[data-pwd-toggle]');
      if (toggle) {
        var input = root.querySelector('#register-password');
        toggle.addEventListener('click', function () {
          if (!input) return;
          var show = input.type === 'password';
          input.type = show ? 'text' : 'password';
          toggle.setAttribute('aria-pressed', show ? 'true' : 'false');
          toggle.setAttribute('aria-label', show ? 'Masquer le mot de passe' : 'Afficher le mot de passe');
          input.focus();
        });
      }
      var errs = root.querySelector('.auth__errors');
      if (errs) { try { errs.focus(); } catch (e) {} }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rail"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-rail-track]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    if (!track) return;

    function step() {
      var item = track.querySelector('.rail__item');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      var w = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      // Scroll by a near-page of cards, snapping to the nearest card width.
      var pageCards = Math.max(1, Math.floor(track.clientWidth / w));
      return w * pageCards;
    }

    function scrollBy(dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
    }

    function update() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
